const initState = {
    files: [],
    filesScopeKey: null,
    filesLoading: false,
    complianceFiles: [],
};

const filesReducer = (state = initState, action) => {


    switch (action.type) {

        case "FILES_REQUEST": {
            const isScopeChange =
                action.scopeKey != null && action.scopeKey !== state.filesScopeKey;
            return {
                ...state,
                files: isScopeChange ? [] : state.files,
                filesScopeKey: action.scopeKey ?? state.filesScopeKey,
                filesLoading: true,
            };
        }

        case "FILES":
            if (
                action.scopeKey != null &&
                state.filesScopeKey != null &&
                action.scopeKey !== state.filesScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                files: action.files,
                filesScopeKey: action.scopeKey ?? state.filesScopeKey,
                filesLoading: false,
            };

        case "FILES_FETCH_FAILED":
            return {
                ...state,
                filesLoading: false,
            };

        case "COMPLIANCE_FILES":
            return {
                ...state,
                complianceFiles: action.files,
            };

        default:
            return state;
    }
};

export default filesReducer;
